import { render, staticRenderFns } from "./GridItemGauge.vue?vue&type=template&id=4e8f8f24&scoped=true&"
import script from "./GridItemGauge.vue?vue&type=script&lang=ts&"
export * from "./GridItemGauge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f8f24",
  null
  
)

export default component.exports